import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["video", "track", "progress", "muteOn", "muteOff"]

  connect() {
    if (this.hasVideoTarget) {
      this.videoTarget.addEventListener(
        "timeupdate",
        this.updateProgress.bind(this),
      )
    }
  }

  updateProgress() {
    if (!this.hasProgressTarget) return
    const { currentTime, duration } = this.videoTarget
    if (!duration) return
    this.progressTarget.style.width = `${(currentTime / duration) * 100}%`
  }

  seek(event) {
    if (!this.hasVideoTarget || !this.videoTarget.duration) return
    const rect = this.trackTarget.getBoundingClientRect()
    const fraction = (event.clientX - rect.left) / rect.width
    this.videoTarget.currentTime =
      Math.min(Math.max(fraction, 0), 1) * this.videoTarget.duration
  }

  toggleMute() {
    if (!this.hasVideoTarget) return
    this.videoTarget.muted = !this.videoTarget.muted
    if (this.hasMuteOnTarget) {
      this.muteOnTarget.classList.toggle("hidden", !this.videoTarget.muted)
    }
    if (this.hasMuteOffTarget) {
      this.muteOffTarget.classList.toggle("hidden", this.videoTarget.muted)
    }
  }
}
